"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var FileList_1 = require("./FileList");
var FileUploadForm_1 = require("./FileUploadForm");
var FileUploadDropArea_1 = require("../FileUploadDropArea");
var __1 = require("../");
var classNames = require("classnames");
var translation_1 = require("../../utils/translation");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileUpload'), (0, recompose_1.mapProps)(function (props) {
    var hasZip = props.value.filter(function (item) { return /^(.*)\.zip$/.test(item.name); }).length > 0;
    var hasDuplicates = hasZip
        ? props.unzip && props.hasDuplicates
        : props.hasDuplicates;
    return {
        onChange: props.onChange,
        toggleReplace: props.toggleReplace,
        value: props.value,
        multipleFiles: props.multipleFiles,
        allowFolder: props.allowFolder,
        unzip: props.unzip,
        replace: props.replace,
        toggleUnzip: props.toggleUnzip,
        uploadedFiles: props.uploadedFiles,
        clearSelection: props.clearSelection,
        showZipSelections: props.showZipSelections,
        hasDuplicates: hasDuplicates,
        hasZip: hasZip,
        uploading: Object.keys(props.uploadedFiles).length > 0,
        accept: props.accept
    };
}), (0, recompose_1.defaultProps)({
    multipleFiles: false,
    uploadedFiles: {},
    showZipSelections: true
}), recompose_1.pure);
exports.FileUpload = enhance(function (props) {
    return (React.createElement("div", { className: 'sok-fileupload-component' },
        props.value.length > 0 ? (React.createElement("div", { className: 'clear-file-selection-container' },
            React.createElement("span", { className: classNames('clear-file-selection', props.uploading ? 'disabled' : ''), onClick: props.clearSelection }, (0, translation_1.getLocalization)('components/FileUpload/clearSelection')))) : null,
        React.createElement("div", { className: 'sok-fileupload-component-container' },
            React.createElement(FileUploadForm_1.FileUploadForm, { onChange: props.onChange, value: props.value, multipleFiles: props.multipleFiles, allowFolder: props.allowFolder, disabled: props.uploading, accept: props.accept }),
            React.createElement(FileUploadDropArea_1.FileUploadDropArea, { multipleFiles: props.multipleFiles, onChange: props.onChange, value: props.value, allowFolder: props.allowFolder, disabled: props.uploading },
                props.value.length === 0 && (React.createElement("div", { className: 'sok-file-upload-drop-area-inner' },
                    React.createElement(__1.Icon, { className: 'fa-cloud-upload' }),
                    React.createElement("span", null, (0, translation_1.getLocalization)('components/FileUpload/FileUploadForm/orDragDropUpload')))),
                props.value.length > 0 && (React.createElement(FileList_1.FileList, { value: props.value, onChange: props.onChange, uploadedFiles: props.uploadedFiles, uploading: props.uploading }))),
            props.showZipSelections &&
                !props.uploading &&
                props.hasZip && [
                React.createElement(__1.Input, { key: 'unzip', type: "checkbox", name: "unzip", label: (0, translation_1.getLocalization)('components/FileUpload/saveZipWithoutExtracting'), elementClassName: 'unzip', value: props.unzip, onClick: function (e) { return props.toggleUnzip(e.target.checked); } }),
                !props.unzip && (React.createElement(__1.Input, { type: "checkbox", name: "replace", label: (0, translation_1.getLocalization)('components/FileUpload/confirmCreateDuplicateFiles'), elementClassName: 'replace', value: !props.replace, onClick: function (e) { return props.toggleReplace(!e.target.checked); } }))
            ],
            !props.uploading && props.hasDuplicates ? (React.createElement(__1.Input, { type: "checkbox", name: "replace", label: (0, translation_1.getLocalization)('components/FileUpload/createRevisionFromSameName'), elementClassName: 'replace', value: props.replace, onClick: function (e) { return props.toggleReplace(e.target.checked); } })) : null)));
});
//# sourceMappingURL=index.js.map